import styles from "./TreeSection.module.css";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import parse from "html-react-parser";
import { useIsMobile } from "../../utils/utils";
import treeBackground from "../../assest/home/backgroundTree.png";
interface RootState {
  links: {
    oliveTree: string;
    noTime: string;
  };
}

interface section5Props {
  pageData: {
    homePageData: {
      no_time: string;
    };
  };
  loading: boolean;
}

const Section5: React.FC<section5Props> = ({ pageData, loading }) => {
  const backgroundImage = useSelector(
    (state: RootState) => state.links.oliveTree
  );

  let text: React.ReactNode = (
    <Skeleton count={3} style={{ width: "300px", marginBottom: "10px" }} />
  );
  if (pageData) {
    text = <>{parse(pageData.homePageData.no_time)}</>;
  }
  const isMobile = useIsMobile();

  return (
    <div
      style={{ backgroundImage: `url(${treeBackground})` }}
      className={styles.container}
    >
      <div className={styles.noTime}>
        <div className={styles.qute}>אין לנו זמן!</div>
        <div className={styles.bodyText}>
          האויב לא שוקט על שמריו. ביהודה שומרון ניטשת מלחמה על השטח. הערבים
          בונים במהירות וכובשים על אדמות רבות מדי יום, כחלק מתוכנית אסטרטגית
          להשתלטות על השטח - שטחי C.
        </div>
      </div>
    </div>
  );
};

export default Section5;
